import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Feature } from '../feature'
export const loadSchemaOnRequest = store.effects.create((feature: Feature) =>
  feature.actions.loadSchema.request.observe().pipe(
    rxjs.switchMap(action => {
      const {
        data: { context },
      } = action
      return feature.api.getModels(context).pipe(
        rxjs.map(models =>
          feature.actions.loadSchema.success
            .from(action)
            .create({ request: { context }, response: { models } }),
        ),
        rxjs.catchError(error =>
          rxjs.of(
            feature.actions.loadSchema.error
              .from(action)
              .create({ error, request: { context } }),
          ),
        ),
      )
    }),
  ),
)
